<template>
  <div>
    <v-card class="mb-4">
      <v-card-text class="pb-0">
        <v-text-field v-model="form.name"
                      label="Name"
                      hint="Must be unique"
                      outlined
                      dense
                      autocomplete="off"
                      required
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('name')"
                      clearable>
        </v-text-field>

        <v-text-field v-model="form.external_id"
                      label="External ID"
                      hint="Optional - The identifier for this brand from another system."
                      outlined
                      dense
                      autocomplete="off"
                      :error-messages="form.errors.get('external_id')"
                      clearable>
        </v-text-field>

        <v-radio-group v-model="form.status"
                       label="Status"
                       class="mt-0">
          <v-radio value="Active"
                   label="Active">
          </v-radio>
          <v-radio value="Inactive"
                   label="Inactive">
          </v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions v-if="brand"
                      class="px-4">
        <div>
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Update
          </v-btn>
          <v-btn :to="{name: 'admin.brands.index'}"
                 :disabled="form.busy">
            Cancel
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click.prevent="deleteBrand"
               color="error"
               :disabled="form.busy">
          Delete
        </v-btn>
      </v-card-actions>
      <v-card-actions v-else
                      class="px-4">
        <v-btn type="submit"
               color="primary"
               :disabled="form.busy">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mb-4">
      <v-card-title>
        {{ form.presentations.length }} {{ form.presentations.length | pluralize('Presentation', false) }}
        <v-spacer></v-spacer>
        <v-text-field v-model="presentationSearch"
                      append-icon="fal fa-search"
                      label="Search"
                      outlined
                      dense
                      hide-details
                      @keydown.enter.prevent=""
                      hint="The name must be unique.">
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="form.presentations"
                      :headers="presentationHeaders"
                      :items="filteredPresentations"
                      :items-per-page="-1"
                      :hide-default-footer="true"
                      :search="presentationSearch"
                      :fixed-header="filteredPresentations.length > 0"
                      :height="filteredPresentations.length ? '400px' : null"
                      dense
                      show-select>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="mb-4"
            :loading="templatesLoading">
      <v-card-title>
        {{ form.templates.length }} Email {{ form.templates.length | pluralize('Template', false) }}
        <v-spacer></v-spacer>
        <v-text-field v-model="templateSearch"
                      append-icon="fal fa-search"
                      label="Search"
                      outlined
                      dense
                      hide-details
                      @keydown.enter.prevent="">
        </v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table v-model="form.templates"
                      :headers="templateHeaders"
                      :items="filteredTemplates"
                      :items-per-page="-1"
                      :hide-default-footer="true"
                      :search="templateSearch"
                      :fixed-header="filteredTemplates.length > 0"
                      :height="filteredTemplates.length ? '400px' : null"
                      dense
                      show-select>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import {isObject, orderBy} from 'lodash';
import {mapGetters} from 'vuex';
import brandService from '../../../services/brandService';
import DOMPurify from 'dompurify';
import {formValidation} from '../../../plugins';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';

export default {
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    brand: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      presentationSearch: '',
      templateSearch: '',
    }
  },
  computed: {
    ...mapGetters([
      'presentations',
      'shareTemplates',
    ]),
    filteredPresentations() {
      return orderBy(this.presentations, ['status', 'slug'], ['asc', 'asc']);
    },
    filteredTemplates() {
      return orderBy(this.shareTemplates, ['status', 'slug'], ['asc', 'asc']);
    },
    presentationHeaders() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Asset ID',
          value: 'external_id',
        },
        {
          text: 'Type',
          value: 'presentation_type',
        },
        {
          text: 'Status',
          value: 'status',
        }
      ]
    },
    templateHeaders() {
      return [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Asset ID',
          value: 'asset_id',
        },
        {
          text: 'Status',
          value: 'status',
        }
      ]
    },
  },
  methods: {
    deleteBrand() {
      if (isObject(this.brand) === false) {
        return;
      }
      if (confirm('Are you sure you want to delete this brand? Associated presentations will NOT be deleted.')) {
        brandService.deleteBrand(this.brand.id)
          .then(() => {
            this.$toast.success('Brand deleted.');
            setTimeout(() => {
              this.$router.replace({name: 'admin.brands.index'});
            }, 500);
          })
          .catch(err => {
            this.$toast.error(DOMPurify.sanitize(err.message));
          })
      }
    }
  }
}
</script>
